import React from 'react';
import cx from 'classnames';

import styles from '../StaticContents.module.scss';

const CookiesText = () => (
	<div className={cx(styles.staticContents, styles.container)}>
		<h1>Cookie policy</h1>
		<div>
			<h3>Our use of cookies</h3>
			<p>
				Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a
				good experience when you use our website and also allows us to improve our site. By continuing to browse the
				site, you are agreeing to our use of cookies.
			</p>
			<h3>What is a cookie?</h3>
			<p>
				At its simplest, a cookie is a small file that a website stores on your computer so it can recognise you when
				you return to the website and remember something about you at a later date.
			</p>
			<h3 className={styles.cookieHeaderSpace}>What kind of cookies does Motorway use?</h3>
			<h4>Strictly necessary cookies</h4>
			<p>
				These are cookies that are required for the operation of our website. They include, for example, cookies that
				enable you to sign into your Motorway account and see your offers again.
			</p>
			<h4>Analytical/performance cookies</h4>
			<p>
				These cookies allow us to recognise and count the number of visitors and to see how visitors move around our
				website when they are using it. This helps us to improve the way our website works, for example, by ensuring
				that users are finding what they are looking for easily.
			</p>
			<h4>Functionality cookies</h4>
			<p>
				These are used to recognise you when you return to our website. This enables us to personalise our content for
				you, greet you by name and remember your preferences.
			</p>
			<h4>Targeting cookies</h4>
			<p>
				These cookies record your visit to our website, the pages you have visited and the links you have followed. We
				will use this information to make our website and the advertising displayed on it more relevant to your
				interests. We may also share this information with third parties for this purpose.
			</p>
			<h4>Third party cookies</h4>
			<p>
				Please note that third parties (including, for example, advertising networks and providers of external services
				like web traffic analysis services) may also use cookies, over which we have no control. These cookies are
				likely to be analytical/performance cookies or targeting cookies.
			</p>
			<h3>Opting-out of cookies</h3>
			<p>
				While continued use of the Motorway website assumes compliance with our current cookie policy, you can change
				your privacy settings at any time.
			</p>
			<p>
				Opting out of cookies is easy, but how do you do it depends on the browser you’re using. The best guide to
				turning off cookies is available at&nbsp;
				<a href="https://www.cookiesandyou.com/disable-cookies" rel="noopener noreferrer" target="_blank">
					cookiesandyou.com
				</a>
				.
			</p>
		</div>
	</div>
);

export default CookiesText;
